import { render, staticRenderFns } from "./WineCatalog.vue?vue&type=template&id=07dee3bb&"
import script from "./WineCatalog.vue?vue&type=script&lang=js&"
export * from "./WineCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports